import _ from 'lodash';
import CustomStore from 'devextreme/data/custom_store';
import request from '../../api';
import { fromSecondsToTime } from '../../helpers/toHHMMSS';
import moment from 'moment';
import { Consts } from '../../res';


export const newsDataGrid = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/news/fullinfo${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/news', values),
    update: async (key, values) => await request.post('/admin/news/update', { ...values, newsId: key }),
    remove: async (key) => await request.delete('/admin/news', { data: { newsId: key } })
});

export const adminsDataGrid = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { users: data, allCount: totalCount } } = await request.get(`/admins/fullinfo${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/new', _.omit(values, 'code')),
    update: async (key, values) => await request.post('/admin/update', { ..._.omit(values, 'code'), userId: key }),
    remove: async (key) => await request.delete('/user', { data: { userId: key } })
});

export const rolesDataGrid = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/access_control/roles/fullinfo${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/access_control/roles/new', values),
    update: async (key, values) => await request.post('/access_control/roles/update', { ...values, id: key }),
    remove: async (key) => await request.delete('/access_control/role', { data: { id: key } })
});

export const roleResourcesDataGrid = (roleId) => new CustomStore({
    key: 'id',
    load: async () => {
        try {
            const { data } = await request.get(`/access_control/permissions/resources/fullinfo/role/${roleId}`);
            return { data, totalCount: Object.keys(data).length };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/access_control/role/resource', { resourceId: values.resource, roleId }),
    remove: async (key) => await request.delete('/access_control/role/resource', { data: { resourceId: key, roleId } })
});
roleResourcesDataGrid.reset = async (roleId, resources) => await request.post('/access_control/role/resources/permissions/reset', { roleId, resources });


export const certSubscriptionsDataGrid = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { supscriptions: supscriptionsRaw, allCount: totalCount, groupCount } } = await request.get(`/supscriptions/users/cert/fullinfo${params}`);
            const data = Object.keys(supscriptionsRaw).map(k => ({ key: k, items: supscriptionsRaw[k] }));
            return { data, totalCount, groupCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/subscribe', { userId: values.userId, subscriptionPackageId: values.supscriptionPackageId, promotionCode: values.promotionId }),
    update: async (key, values) => await request.post('/admin/subscribe/update', { ...values, userSupscriptionId: key }),
    // remove: async (key) => await request.delete('/supscription/package', { data: { packageId: key } })
});

export const coursesSubscriptionsDataGrid = (setLog) => new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { supscriptions: data, allCount: totalCount } } = await request.get(`/supscriptions/users/courses/fullinfo${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => {
        const res = await request.post('/admin/subscribe', { userId: values.userId, subscriptionPackageId: values.supscriptionPackageId, promotionCode: values.promotionId, usersEmails: values.usersEmails, subscrPkgPackId: values.subscrPkgPackId });
        if (res.data?.failedCases?.length && res.data?.totalCnt) {
            setLog(res.data);
        }
        return res;
    },

    update: async (key, values) => await request.post('/admin/subscribe/update', { ...values, userSupscriptionId: key }),    // remove: async (key) => await request.delete('/supscription/package', { data: { packageId: key } })
});

export const unitsSubscriptionsDataGrid = (setLog) => new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { supscriptions: data, allCount: totalCount } } = await request.get(`/supscriptions/users/level/units/fullinfo${params}`);
            //const data = Object.keys(supscriptionsRaw).map(k => ({ key: k, items: supscriptionsRaw[k] }));
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => {
        const res = await request.post('/admin/subscribe', { userId: values.userId, subscriptionPackageId: values.supscriptionPackageId, promotionCode: values.promotionId, usersEmails: values.usersEmails, subscrPkgPackId: values.subscrPkgPackId });
        if (res.data?.failedCases?.length && res.data?.totalCnt) {
            setLog(res.data);
        }
        return res;
    },
    update: async (key, values) => await request.post('/admin/subscribe/update', { ...values, userSupscriptionId: key }),    // remove: async (key) => await request.delete('/supscription/package', { data: { packageId: key } })
});


export const unitsDataGrid = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { units: unitsRaw, allCount: totalCount, groupCount } } = await request.get(`/units/fullinfo${params}`);
            const data = Object.keys(unitsRaw).map(k => ({ key: k, items: unitsRaw[k] }));
            return { data, totalCount, groupCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/unit/new', values),
    update: async (key, values) => await request.post('/unit/update', { ...values, unitId: key }),
    remove: async (key) => await request.delete('/unit', { data: { unitId: key } })
});

export const topicsDataGrid = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { topics: data, allCount: totalCount } } = await request.get(`/topics/fullinfo${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/topic/new', values),
    update: async (key, values) => await request.post('/topic/update', { ...values, topicId: key }),
    remove: async (key) => await request.delete('/topic', { data: { topicId: key } })
});

export const promotionsDataGrid = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { promotions: data, allCount: totalCount } } = await request.get(`/supscription/promotions/fullinfo${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/supscription/promotion/new', values),
    update: async (key, values) => await request.post('/supscription/promotion/update', { ...values, promotionId: key }),
    remove: async (key) => await request.delete('/supscription/promotion', { data: { promotionId: key } })
});


export const certPackagesDataGrid = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { packages: packagesRaw, allCount: totalCount, groupCount } } = await request.get(`/supscription/packages/certificate/fullinfo${params}`);
            const data = Object.keys(packagesRaw).map(k => ({ key: k, items: packagesRaw[k] }));
            return { data, totalCount, groupCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/supscription/package/certificate/new', { ...values, validitySeconds: values.validitySeconds * 60 * 60 * 24 }),
    update: async (key, values) => await request.post('/supscription/package/update', { ...values, validitySeconds: values.validitySeconds * 60 * 60 * 24, packageId: key }),
    remove: async (key) => await request.delete('/supscription/package', { data: { packageId: key } })
});

export const coursesPackagesDataGrid = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { packages: packagesRaw, allCount: totalCount, groupCount } } = await request.get(`/supscription/packages/course/fullinfo${params}`);
            const data = Object.keys(packagesRaw).map(k => ({ key: k, items: packagesRaw[k] }));
            return { data, totalCount, groupCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/supscription/package/course/new', { ...values, validitySeconds: values.validitySeconds * 60 * 60 * 24 }),
    update: async (key, values) => await request.post('/supscription/package/update', { ...values, validitySeconds: values.validitySeconds * 60 * 60 * 24, packageId: key }),
    remove: async (key) => await request.delete('/supscription/package', { data: { packageId: key } })
});
coursesPackagesDataGrid.copyPackage = async (subscrPkgId) => await request.post('/admin/copy/subscr-pkg', { subscrPkgId });

export const unitsPackagesDataGrid = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { packages, allCount: totalCount, groupCount } } = await request.get(`/supscription/packages/units/fullinfo${params}`);
            return { data: packages, totalCount, groupCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/supscription/package/units/new', { ...values, validitySeconds: values.validitySeconds * 60 * 60 * 24 }),
    update: async (key, values) => await request.post('/supscription/package/update', { ...values, validitySeconds: values.validitySeconds * 60 * 60 * 24, packageId: key }),
    remove: async (key) => await request.delete('/supscription/package', { data: { packageId: key } })
});

export const featuresPackagesDataGrid = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'searchValue', 'searchExpr', 'searchOperation'].forEach(function (i) {
                if (i in loadOptions && loadOptions[i]) {
                    params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                }
            });
            params = params.slice(0, -1);
            const { data: { features, allCount: totalCount } } = await request.get(`/supscription/features/fullinfo${params}`);
            return { data: Object.values(features), totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/subscription/feature', values),
    update: async (key, values) => await request.put('/admin/subscription/feature', { ...values, id: key }),
    // remove: async (key) => await request.delete('/supscription/package', { data: { packageId: key } })
});

export const certsDataGrid = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { certificates: data, allCount: totalCount } } = await request.get(`/certificates/fullinfo${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/certificate/new', values),
    update: async (key, values) => await request.post('/certificate/update', { ...values, certificateId: key }),
    remove: async (key) => await request.delete('/certificate', { data: { certificateId: key } })
});

export const coursesDataGrid = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { courses: coursesRaw, allCount: totalCount, groupCount } } = await request.get(`/courses/cert/fullinfo${params}`);
            const data = Object.keys(coursesRaw).map(k => ({ key: k, items: coursesRaw[k] }));
            return { data, totalCount, groupCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/course/new', values),
    update: async (key, values) => await request.post('/course/update', { ...values, courseId: key }),
    remove: async (key) => await request.delete('/course', { data: { courseId: key } })
});
coursesDataGrid.copyCourse = async (courseId, bookMode = 'reuse') => await request.post('/admin/copy/course', { courseId, bookMode });

export const oneDayCoursesDataGrid = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { courses: data, allCount: totalCount } } = await request.get(`/courses/oneday/fullinfo${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/course/new', values),
    update: async (key, values) => await request.post('/course/update', { ...values, courseId: key }),
    remove: async (key) => await request.delete('/course', { data: { courseId: key } })
});

export const categoriesDataGrid = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/questions/categories/fullinfo${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/questions/category/new', values),
    update: async (key, values) => await request.post('/questions/category/update', { ...values, id: key }),
    remove: async (key) => await request.delete('/questions/category', { data: { id: key } })
});

export const difficultiesDataGrid = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/questions/difficulties/fullinfo${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/questions/difficulty/new', values),
    update: async (key, values) => await request.post('/questions/difficulty/update', { ...values, id: key }),
    remove: async (key) => await request.delete('/questions/difficulty', { data: { id: key } })
});


export const sizesDataGrid = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/questions/sizes/fullinfo${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/questions/size/new', values),
    update: async (key, values) => await request.post('/questions/size/update', { ...values, id: key }),
    remove: async (key) => await request.delete('/questions/size', { data: { id: key } })
});


export const factsDataGrid = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort', 'courseId', 'unitId', 'topicId']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { data: questionsRaw, allCount: totalCount } } = await request.get(`/questions/facts/fullinfo${params}`);
            // const data = Object.keys(questionsRaw).map(k => ({ key: k, items: questionsRaw[k] }));
            return { data: questionsRaw, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/questions/fact/new', values),
    update: async (key, values) => await request.post('/questions/fact/update', { ...values, factId: key }),
    remove: async (key) => await request.delete('/questions/fact', { data: { factId: key } })
});

export const essaysQuestionsDataGrid = (factId) => new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params += `factId=${factId}&`;
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount, groupCount } } = await request.get(`/questions/essay/fullinfo${params}`);
            return { data, totalCount, groupCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/questions/question/essay/new', values),
    update: async (key, values) => await request.post('/questions/question/update', { ...values, questionId: key }),
    remove: async (key) => await request.delete('/questions/question', { data: { questionId: key } })
});


export const mcqsQuestionsDataGrid = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort', 'groupSummary', 'courseId', 'unitId', 'topicId']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { data: questionsRaw, allCount: totalCount } } = await request.get(`/questions/mcq/fullinfo${params}`);
            // const data = Object.keys(questionsRaw).map((k, indx) => ({ key: k, items: questionsRaw[k], summary: [summary[indx]] }));
            return { data: questionsRaw, totalCount, summary: [totalCount] };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/questions/question/mcq/new', values),
    update: async (key, values) => await request.post('/questions/question/update', { ...values, questionId: key }),
    remove: async (key) => await request.delete('/questions/question', { data: { questionId: key } })
});


export const mcqsQuestionsBatchData = new CustomStore({
    key: 'id',
    insert: async (values) => await request.post('/questions/question/mcq/overall/new', values),
});

export const optionsDataGrid = (questionId) => new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            if (questionId)
                params += `questionId=${questionId}&`;
            params = params.slice(0, -1);
            const { data: { data: raw, allCount } } = await request.get(`/admin/questions/options/fullinfo${params}`);
            const data = raw.map(r => {
                const ob = {
                    ...r,
                    ...r.contents.reduce((obj, item) => Object.assign(obj, { [`${[item.colNameEn]}|${[item.columnId]}|En`]: item.contentEn, [`${[item.colNameAr]}|${[item.columnId]}|Ar`]: item.contentAr }), {})
                };

                // delete ob['contents'];
                return ob;
            });

            return { data, totalCount: allCount || data.length };

        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/questions/option/new', { ...prepareValuesToSend(values), questionId }),
    update: async (key, values) => await request.post('/questions/option/update', { ...prepareValuesToSend(values), optionId: key, questionId }),
    remove: async (key) => await request.delete('/questions/option', { data: { optionId: key } })
});

const prepareValuesToSend = (obj) => {
    let data = {};
    const contents = [];
    Object.keys(obj).map(o => {

        if (o.split('|')[1]) {
            let cc = contents.find(c => c.columnId === o.split('|')[1]);
            if (!cc) {
                cc = { columnId: o.split('|')[1] };
                if (o.split('|')[2] === 'En') cc['contentEn'] = obj[o];
                else if (o.split('|')[2] === 'Ar') cc['contentAr'] = obj[o];
                contents.push(cc);
            } else {
                contents.find(c => c.columnId === o.split('|')[1]).contentEn = o.split('|')[2] === 'En' ? obj[o] : contents.find(c => c.columnId === o.split('|')[1]).contentEn;
                contents.find(c => c.columnId === o.split('|')[1]).contentAr = o.split('|')[2] === 'Ar' ? obj[o] : contents.find(c => c.columnId === o.split('|')[1]).contentAr;
            }
        } else data = { ...data, [o]: obj[o] };

        if (contents.length);
        data = { ...data, contents };
        return data;
    });

    return data;
};


export const textQuestionsDataGrid = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { data: questionsRaw, allCount: totalCount, groupCount } } = await request.get(`/questions/text/fullinfo${params}`);
            const data = Object.keys(questionsRaw).map(k => ({ key: k, items: questionsRaw[k] }));
            return { data, totalCount, groupCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/questions/question/text/new', values),
    update: async (key, values) => await request.post('/questions/question/update', { ...values, questionId: key }),
    remove: async (key) => await request.delete('/questions/question', { data: { questionId: key } })
});

export const compositeQuestionsDataGrid = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort', 'groupSummary', 'courseId', 'unitId', 'topicId']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { data: questionsRaw, allCount: totalCount } } = await request.get(`/questions/composite/fullinfo${params}`);
            // const data = Object.keys(questionsRaw).map((k, indx) => ({ key: k, items: questionsRaw[k], summary: [summary[indx]] }));
            return { data: questionsRaw, totalCount, summary: [totalCount] };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/questions/question/composite/new', values),
    update: async (key, values) => await request.post('/questions/question/update', { ...values, questionId: key }),
    remove: async (key) => await request.delete('/questions/question', { data: { questionId: key } })
});

export const fileQuestionsDataGrid = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort', 'groupSummary', 'courseId', 'unitId', 'topicId']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { data: questionsRaw, allCount: totalCount } } = await request.get(`/questions/afiles/fullinfo${params}`);
            return { data: questionsRaw, totalCount, summary: [totalCount] };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/questions/question/afiles/new', values),
    update: async (key, values) => await request.post('/questions/question/update', { ...values, questionId: key }),
    remove: async (key) => await request.delete('/questions/question', { data: { questionId: key } })
});


export const attachmentsQuestionsDataGrid = (questionId) => new CustomStore({
    key: 'docId',
    load: async () => {
        try {
            const { data: { data: questionsRaw, allCount: totalCount } } = await request.get(`/admin/question/${questionId}/docs/fullinfo`);
            return { data: questionsRaw, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/question/doc', values),
    update: async (key, values) => await request.put('/admin/question/doc', { ...values, questionId, docId: key }),
    remove: async (key) => await request.delete('/admin/question/doc', { data: { docId: key, questionId } })
});

export const usersDataGrid = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { users: data, allCount: totalCount } } = await request.get(`/students/fullinfo${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/student/new', _.omit(values, 'code')),
    update: async (key, values) => await request.post('/student/update', { ..._.omit(values, 'code'), userId: key }),
    remove: async (key) => await request.delete('/user', { data: { userId: key } })
});
usersDataGrid.resetPerformance = async (userId, courseId) => await request.post('/admin/user/prefs', { userId, courseId, resetPerformBefore: new Date() });


export const instructorsDataGrid = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/instructors/fullinfo${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/instructor', values),
    update: async (key, values) => await request.post('/admin/instructor/update', { ...values, instructorId: key }),
    remove: async (key) => await request.delete('/admin/instructor', { data: { instructorId: key } })
});
instructorsDataGrid.getAssets = async (instructorId) => await request(`/admin/instructor/${instructorId}/distributions`);
instructorsDataGrid.setAssets = async (values) => await request.post('/admin/instructor/distribution/reset', values);

export const successStoriesDataGrid = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/success_stories/fullinfo${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/success_story', values),
    update: async (key, values) => await request.post('/admin/success_story/update', { ...values, successStoryId: key }),
    remove: async (key) => await request.delete('/admin/success_story', { data: { successStoryId: key } })
});
successStoriesDataGrid.getAssets = async (successStoryId) => await request(`/admin/success_story/${successStoryId}/distributions`);
successStoriesDataGrid.setAssets = async (values) => await request.post('/admin/success_story/distribution/reset', values);

export const multiIpUsersDataGrid = new CustomStore({
    key: 'userId',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'filter', 'sort', 'from', 'to', 'devicesCnt', 'useIps']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/dashboard/users/multi_locations${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
});

export const multiIpUserDetailsDataGrid = (userId, useIps) => new CustomStore({
    key: 'firstCreateAt',
    load: async () => {
        try {
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/dashboard/user/${userId}/locations_info?useIps=${useIps}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
});

export const paymentsReportDataGrid = new CustomStore({
    key: 'paymentId',
    load: async (loadOptions) => {
        try {
            let params = '?';
            let allDataParams = '?';
            ['skip', 'take', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);

            ['filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        allDataParams += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            allDataParams = allDataParams.slice(0, -1);


            const promise1 = request.get(`/payments/completed/all${params}`);
            const promise2 = request.get(`/payments/completed/all${allDataParams}`);
            const [{ data: { data, allCount: totalCount } }, { data: { data: allData } }] = await Promise.all([promise1, promise2]);

            return { data, totalCount, summary: [allData.reduce((acc, i) => i.paymentAmountUSD + acc, 0)] };
        } catch (err) {
            return err;
        }
    },

    update: async (key, values) => await request.post('/admin/payment/update', { ...values, paymentId: key }),
});

export const ManualPaymentsDataGrid = new CustomStore({
    key: 'paymentId',
    load: async (loadOptions) => {
        try {
            let params = '?';
            let allDataParams = '?';
            ['skip', 'take', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);

            ['filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        allDataParams += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            allDataParams = allDataParams.slice(0, -1);


            const promise1 = request.get(`/admin/payments/manual${params}`);
            const promise2 = request.get(`/admin/payments/manual${allDataParams}`);
            const [{ data: { data, allCount: totalCount } }, { data: { data: allData } }] = await Promise.all([promise1, promise2]);

            return { data, totalCount, summary: [allData.reduce((acc, i) => i.amountUSD + acc, 0)] };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/payment', values),
    update: async (key, values) => await request.post('/admin/payment/update', { ...values, paymentId: key }),
    remove: async (key) => await request.delete('/payment', { data: { paymentId: key } })
});


export const examsDataGrid = new CustomStore({
    key: 'examId',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['filter', 'group', 'skip', 'sort', 'take', 'requireGroupCount', 'requireTotalCount']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params += 'types=FREQ_PARENT,FREQ&';
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount, groupCount } } = await request.get(`/admin/exams/fullinfo${params}`);
            return { data, totalCount, groupCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/exam', { ...values, explainVideoId: values.explainVideoUrl, durationSeconds: values.durationSeconds * 60 }),
    update: async (key, values) => await request.post('/admin/exam/update', { ...values, explainVideoId: values.explainVideoUrl, durationSeconds: values.durationSeconds * 60, examId: key }),
    remove: async (key) => await request.delete('/admin/exam', { data: { examId: key } })
});
examsDataGrid.copyParent = async (examId) => await request.post('/admin/copy/exam', { examId });


export const examsQuestionsDistributionDataGrid = (examId) => new CustomStore({
    key: 'examQuestionDistId',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/exam/${examId}/questions/dist${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/exam/questions/dist', values),
    update: async (key, values) => await request.put('/admin/exam/questions/dist', { ...values, examQuestionDistId: key }),
    remove: async (key) => await request.delete('/admin/exam/questions/dist', { data: { examQuestionDistIds: key } })
});
examsQuestionsDistributionDataGrid.addBatch = async (data) => await request.post('/admin/exam/questions/dist', data);
examsQuestionsDistributionDataGrid.deleteBatch = async (data) => await request.delete('/admin/exam/questions/dist', { data });


export const examsCorrectionDataGrid = (courseId, questionsType, examTypes, date, user) => new CustomStore({
    key: 'examRoundId',
    load: async (loadOptions) => {
        let isMock = 0;
        const resolveExamTypes = (examTypes) => {
            switch (examTypes) {
                case "Test_Knowledge": return [Consts.EXAM_TYPES.TEST_MCQS, Consts.EXAM_TYPES.TEST_ESSAY, Consts.EXAM_TYPES.TEST_TBS, Consts.EXAM_TYPES.TEST_FILE];
                case "Bank": return [Consts.EXAM_TYPES.MCQS, Consts.EXAM_TYPES.ESSAY, Consts.EXAM_TYPES.TEST_TBS, Consts.EXAM_TYPES.FILE];
                case "Freq": return [Consts.EXAM_TYPES.FREQ];
                case "Mock": isMock = 1; return [Consts.EXAM_TYPES.FREQ];
                default: return [];
            }
        };
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params += `groupby=${false}&`;
            params += `courseId=${courseId}&`;
            params += `mustBeFinished=${true}&`;
            params += `examQuestionsTypes=${questionsType?.join(',')}&`;
            params += `examTypes=${resolveExamTypes(examTypes)?.join(',')}&`;
            if (isMock) params += `isMock=1&`;
            if (user) params += `userId=${user}&`;
            if (date?.[0]) params += `startDateFrom=${moment(date[0]).locale("en").format("YYYY-MM-DD")}&`;
            if (date?.[1]) params += `startDateTo=${moment(date[1]).locale("en").format("YYYY-MM-DD")}&`;
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/exams/rounds/fullinfo${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/exam', { ...values, explainVideoId: values.explainVideoUrl, durationSeconds: values.durationSeconds * 60 }),
    update: async (key, values) => await request.post('/admin/exam/update', { ...values, explainVideoId: values.explainVideoUrl, durationSeconds: values.durationSeconds * 60, examId: key }),
    remove: async (key) => await request.delete('/admin/exam', { data: { examId: key } })
});

export const coursesCalendarDataGrid = new CustomStore({
    key: 'calendarId',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });

            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/calendar/courses/fullinfo${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/calendar/course', values),
    update: async (key, values) => await request.post('/admin/calendar/course/update', { ...values, calendarId: key }),
    remove: async (key) => await request.delete('/admin/calendar/courses', { data: { calendarId: key } })
});

export const reportsDataGrid = (type) => new CustomStore({
    key: 'issueReportId',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });

            if (type) params += `reportOn=${type}&`;
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/issues_reports/fullinfo${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    // insert: async (values) => await request.post('/admin/calendar/course', values),
    update: async (key, values) => await request.post('/admin/issue_report/update', { ...values, issueReportId: key }),
    remove: async (key) => await request.delete('/admin/issue_report', { data: { issueReportId: key } })
});

export const settingsDataGrid = (category) => new CustomStore({
    key: 'idSetting',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });

            if (category) params += `category=${category}&`;
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/settings/fullinfo${params}`);
            return { data: data.map(i => ({ ...i, isActive: i.value[0], isImportant: i.value[1], useEmail: i.value[2] })), totalCount };
        } catch (err) {
            return err;
        }
    },
    update: async (key, values) => await request.post('/admin/settings/update', { idSetting: key, value: `${values.isActive ? '1' : '0'}${values.isImportant ? '1' : '0'}${values.useEmail ? '1' : '0'}` }),
});


export const honorRollDataGrid = new CustomStore({
    key: 'honorId',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/honors${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/honor', values),
    update: async (key, values) => await request.post('/admin/honor/update', { ...values, honorId: key }),
    remove: async (key) => await request.delete('/admin/honor', { data: { honorId: key } })
});


export const userVideoComments = (videoId) => new CustomStore({
    key: 'videoNoteId',
    load: async () => {
        try {
            const { data: { data } } = await request.get(`/student/video-notes/${videoId}`);
            return data;
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post(`/student/video-note/${videoId}`, values),
    update: async (key, values) => await request.post('/student/video-note/update', { ...values, videoNoteId: key }),
    remove: async (key) => await request.delete('/student/video-note', { data: { videoNoteId: key } })
});

export const videoSegmentsDataGrid = (videoId) => new CustomStore({
    key: 'id',
    load: async () => {
        try {
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/videos/segments?videoId=${videoId}`);
            return {
                data: data.map(d => {
                    const [fromH, fromM, fromS] = fromSecondsToTime(d.fromSecond);
                    const [toH, toM, toS] = fromSecondsToTime(d.toSecond);
                    return { ...d, fromH, fromM, fromS, toH, toM, toS };
                }), totalCount
            };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/video/segment', {
        ...values, videoId,
        fromSecond: (values.fromS || 0) + ((values.fromM || 0) * 60) + ((values.fromH || 0) * 3600),
        toSecond: (values.toS || 0) + ((values.toM || 0) * 60) + ((values.toH || 0) * 3600),
    }),
    update: async (key, values) => await request.put('/admin/video/segment', { ...values, id: key, videoId }),
    remove: async (key) => await request.delete('/video/segment', { data: { id: key } })
});

export const teamMembersDataGrid = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/team-member${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/team-member', values),
    update: async (key, values) => await request.post('/admin/team-member/update', { ...values, id: key }),
    remove: async (key) => await request.delete('/admin/team-member', { data: { id: key } })
});

export const examLinksDataGrid = (examId) => new CustomStore({
    key: 'examLinkId',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            if (examId) params += `examId=${examId}&`;
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/exam/links${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/exam/link', values),
    update: async (key, values) => await request.put('/admin/exam/link', { ...values, examLinkId: key }),
    remove: async (key) => await request.delete('/admin/exam/link', { data: { examLinkId: key } })
});

export const blogCategoriesDataGrid = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/categories/blog${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/category/blog', values),
    update: async (key, values) => await request.put('/admin/category/blog', { ...values, id: key }),
    remove: async (key) => await request.delete('/admin/category/blog', { data: { id: key } })
});

export const blogTagsDataGrid = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/tags${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/tag', values),
    update: async (key, values) => await request.put('/admin/tag', { ...values, id: key }),
    remove: async (key) => await request.delete('/admin/tag', { data: { id: key } })
});

export const blogsDataGrid = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/blogs${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/blog', { ...values, contentJson: values?.contentJson ? values.contentJson : JSON.stringify({ blocks: [], settings: {} }) }),
    update: async (key, values) => await request.put('/admin/blog', { ...values, id: key }),
    remove: async (key) => await request.delete('/admin/blog', { data: { id: key } })
});

export const FAQsDataGrid = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/faqs${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/faq', values),
    update: async (key, values) => await request.post('/admin/faq/update', { ...values, id: key }),
    remove: async (key) => await request.delete('/admin/faq', { data: { id: key } })
});


export const uploadCoursesVideosDataGrid = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort', 'courseId', 'unitId', 'topicId']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/videos/fullinfo${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/video/new', values),
    update: async (key, values) => await request.put('/video/update', { ...values, videoId: key }),
    remove: async (key) => await request.delete('/video/topic', { data: { videoId: key } })
});

export const uploadCoursesBooksDataGrid = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort', 'courseId', 'unitId', 'topicId']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/books/fullinfo${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/book', values),
    update: async (key, values) => await request.put('/admin/book', { ...values, bookId: key }),
    remove: async (key) => await request.delete('/admin/book/topic', { data: { bookId: key } })
});

/*
 * Course resources — the files a course offers for download. The update sends
 * the metadata only (names, descriptions, type, rank): the API does not change
 * a resource's files or sizes after it is created, and its courses have their
 * own request (`resetCourses`). A delete is the API's soft delete, from every
 * course at once.
 *
 * The list comes back a row per resource *and course*: a resource in two
 * courses is two rows with the same id. It is paged by those rows, and its
 * `allCount` counts resources without a filter and rows with one. So the whole
 * list is loaded, folded into a row per resource carrying all its `coursesIds`,
 * and the grid pages, filters and sorts it itself (`remoteOperations` off) —
 * there are tens of resources, not thousands.
 */
const RESOURCE_METADATA = ['nameEn', 'nameAr', 'descriptionEn', 'descriptionAr', 'type', 'rank'];

export const courseResourcesDataGrid = new CustomStore({
    key: 'id',
    load: async () => {
        try {
            const { data: { data } } = await request.get('/resources/fullinfo');
            const byId = new Map();
            (data ?? []).forEach((row) => {
                const resource = byId.get(row.id) ?? { ...row, coursesIds: [] };
                if (row.courseId != null && !resource.coursesIds.includes(row.courseId)) resource.coursesIds.push(row.courseId);
                byId.set(row.id, resource);
            });
            return [...byId.values()];
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/resource', values),
    update: async (key, values) => await request.put('/admin/resource', {
        ...Object.fromEntries(RESOURCE_METADATA.filter((field) => field in values).map((field) => [field, values[field]])),
        resourceId: key
    }),
    remove: async (key) => await request.delete('/admin/resource', { data: { resourceId: key } })
});

courseResourcesDataGrid.getCourses = async (resourceId) => {
    const { data: { data } } = await request.get(`/admin/resources/${resourceId}/courses`);
    return data;
};

courseResourcesDataGrid.resetCourses = async (resourceId, coursesIds) =>
    await request.put('/admin/resource/courses', { resourceId, coursesIds });

export const packagePoliciesDataGrid = new CustomStore({
    key: 'policyId',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/policy${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/policy', values),
    update: async (key, values) => await request.put('/admin/policy', { ...values, policyId: key }),
    remove: async (key) => await request.delete('/admin/policy', { data: { policyId: key } })
});


export const usersPerformancesDataGrid = (courseId, topicsIds, packageId, date, userId, fields) => new CustomStore({
    key: 'email',
    load: async (loadOptions) => {
        const allFields = ["videos", "books", "mcq", "essay", "composite", "afiles"];
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });

            if (topicsIds?.length) params += `topicsIds=${topicsIds.join(',')}&`;
            if (packageId) params += `subscrPackageId=${packageId}&`;
            if (date?.[0]) params += `fromDate=${moment(date[0]).locale("en").format("YYYY-MM-DD")}&`;
            if (date?.[1]) params += `toDate=${moment(date[1]).locale("en").format("YYYY-MM-DD")}&`;
            if (userId) params += `userId=${userId}&`;
            if (fields?.length) {
                const diff = allFields.filter(item => !fields.includes(item));
                if (diff?.length) params += `includeFields=${JSON.stringify(diff.reduce((obj, item) => ({ ...obj, [item]: false }), {}))}&`;
            }
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/performance/users/course/${courseId}${params}`);
            return {
                data: data.map(p => {
                    try {
                        const perofrmanceColumns = JSON.parse(p?.performance || "{}");
                        const pastPerformance = JSON.parse(p?.wholePerformance || "{}");
                        const subscriptions = JSON.parse(p.lastSubscr || "{}");
                        return { ...p, ...perofrmanceColumns, pastPerformance, ...subscriptions };
                    } catch (error) {
                        return {};
                    }
                })
                , totalCount
            };
        } catch (err) {
            return err;
        }
    }
});

export const userPerformanceNotesDataGrid = (userId, courseId) => new CustomStore({
    key: 'userNoteId',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            if (courseId) params += `courseId=${courseId}&`;
            if (userId) params += `userId=${userId}&`;
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/user/note${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/user/note', values),
    update: async (key, values) => await request.put('/admin/user/note', { ...values, userNoteId: key }),
    remove: async (key) => await request.delete('/admin/user/note', { data: { userNoteId: key } })
});

export { packagePropertiesDataGrid } from './Package Properties Store';

export const packageCategoriesDataGrid = new CustomStore({
    key: 'categoryId',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/supscription/package/category${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/supscription/package/category', values),
    update: async (key, values) => await request.put('/admin/supscription/package/category', { ...values, categoryId: key }),
    remove: async (key) => await request.delete('/admin/supscription/package/category', { data: { categoryId: key } })
});

export const certAttendanceDataGrid = new CustomStore({
    key: 'certAttendId',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/cert-attend${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/cert-attend', values),
    update: async (key, values) => await request.put('/admin/cert-attend', { ...values, certAttendId: key }),
    remove: async (key) => await request.delete('/admin/cert-attend', { data: { certAttendId: key } })
});

export const certUserAttendanceDataGrid = new CustomStore({
    key: 'certAttendReleaseId',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/cert-attend/releases${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/cert-attend/releases/gen', values),
    update: async (key, values) => await request.put('/admin/cert-attend/releases', { ...values, certAttendReleaseId: key }),
    remove: async (key) => await request.delete('/admin/cert-attend/releases', { data: { certAttendReleaseId: key } })
});

export const badgesDataGrid = new CustomStore({
    key: 'badgeId',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/badges${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/badges', values),
    update: async (key, values) => await request.put('/admin/badges', { ...values, badgeId: key }),
    remove: async (key) => await request.delete('/admin/badges', { data: { badgeId: key } })
});

export const badgesUserDataGrid = new CustomStore({
    key: 'badgeReleaseId',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/badges/releases${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/badges/releases/gen', values),
    update: async (key, values) => await request.put('/admin/badges/releases', { ...values, badgeReleaseId: key }),
    remove: async (key) => await request.delete('/admin/badges/releases', { data: { badgeReleaseId: key } })
});


export const companiesRequestsDataGrid = new CustomStore({
    key: 'buisnessReqId',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/buisness-req${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/buisness-req', values),
    update: async (key, values) => await request.put('/admin/buisness-req', { ...values, buisnessReqId: key }),
    remove: async (key) => await request.delete('/admin/buisness-req', { data: { buisnessReqId: key } })
});

export const companiesRequestsOrdersDataGrid = (buisnessReqId) => new CustomStore({
    key: 'buisnessReqOrderId',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            if (buisnessReqId) params += `buisnessReqId=${buisnessReqId}&`;
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/buisness-req/order${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/buisness-req/order', values),
    update: async (key, values) => await request.put('/admin/buisness-req/order', { ...values, buisnessReqOrderId: key }),
    remove: async (key) => await request.delete('/admin/buisness-req/order', { data: { buisnessReqOrderId: key } })
});

export const companiesDataGrid = new CustomStore({
    key: 'companyId',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/company${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/company', values),
    update: async (key, values) => await request.put('/admin/company', { ...values, companyId: key }),
    remove: async (key) => await request.delete('/admin/company', { data: { companyId: key } })
});

export const companiesRepresentativesDataGrid = (companyId) => new CustomStore({
    key: 'representativeId',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            if (companyId) params += `companyId=${companyId}&`;
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/representative${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/representative', values),
    update: async (key, values) => await request.put('/admin/representative', { ...values, representativeId: key }),
    remove: async (key) => await request.delete('/admin/representative', { data: { representativeId: key } })
});

export const companiesProposalsDataGrid = (representativeId) => new CustomStore({
    key: 'proposalId',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['filter', 'group', 'skip', 'sort', 'take', 'requireGroupCount', 'requireTotalCount']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            if (representativeId) params += `representativeId=${representativeId}&`;
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount, groupCount } } = await request.get(`/admin/proposal${params}`);
            return { data, totalCount, groupCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/proposal', values),
    update: async (key, values) => await request.put('/admin/proposal', { ...values, proposalId: key }),
    remove: async (key) => await request.delete('/admin/proposal', { data: { proposalId: key } })
});

export const companiesOrdersDataGrid = (proposalId) => new CustomStore({
    key: 'orderId',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            if (proposalId) params += `proposalId=${proposalId}&`;
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/order${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/order', values),
    update: async (key, values) => await request.put('/admin/order', { ...values, orderId: key }),
    remove: async (key) => await request.delete('/admin/order', { data: { orderId: key } })
});

export const companiesOrdersWorksheetsDataGrid = (orderId) => new CustomStore({
    key: 'orderActionId',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            if (orderId) params += `orderId=${orderId}&`;
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/order/action${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/order/action', values),
    update: async (key, values) => await request.put('/admin/order/action', { ...values, orderActionId: key }),
    remove: async (key) => await request.delete('/admin/order/action', { data: { orderActionId: key } })
});

export const companiesOrdersInstructorsDataGrid = (orderId) => new CustomStore({
    key: 'orderInstructorId',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });
            if (orderId) params += `orderId=${orderId}&`;
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/order/instructor${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/order/instructor', values),
    update: async (key, values) => await request.put('/admin/order/instructor', { ...values, orderInstructorId: key }),
    remove: async (key) => await request.delete('/admin/order/instructor', { data: { orderInstructorId: key } })
});

export const companiesCoursesDataGrid = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });

            params += `type=buisness&`;
            params = params.slice(0, -1);
            const { data: { courses: data, allCount: totalCount } } = await request.get(`/courses/fullinfo${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/course/new', values),
    update: async (key, values) => await request.post('/course/update', { ...values, courseId: key }),
    remove: async (key) => await request.delete('/course', { data: { courseId: key } })
});

export const bannersDataGrid = new CustomStore({
    key: 'bannerId',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });

            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/banner${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/banner', values),
    update: async (key, values) => await request.put('/admin/banner', { ...values, bannerId: key }),
    remove: async (key) => await request.delete('/admin/banner', { data: { bannerId: key } })
});

export const certificateBlogsDataGrid = (certId) => new CustomStore({
    key: 'blogDistId',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });

            if (certId) params += `certId=${certId}&`;
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/dist/blog${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/dist/blog', values),
    update: async (key, values) => await request.put('/admin/dist/blog', { ...values, blogDistId: key }),
    remove: async (key) => await request.delete('/admin/dist/blog', { data: { blogDistId: key } })
});

export const accreditDataGrid = new CustomStore({
    key: 'accreditId',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });

            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/accredit${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/accredit', values),
    update: async (key, values) => await request.put('/admin/accredit', { ...values, accreditId: key }),
    remove: async (key) => await request.delete('/admin/accredit', { data: { accreditId: key } })
});

export const certificateAccreditsDataGrid = (certId) => new CustomStore({
    key: 'accreditDistId',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });

            if (certId) params += `certId=${certId}&`;
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/dist/accredit${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/dist/accredit', values),
    update: async (key, values) => await request.put('/admin/dist/accredit', { ...values, accreditDistId: key }),
    remove: async (key) => await request.delete('/admin/dist/accredit', { data: { accreditDistId: key } })
});

export const packagesPacksDataGrid = new CustomStore({
    key: 'subscrPkgPackId',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });

            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/supscription/pkg/packs${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/supscription/pkg/pack', values),
    update: async (key, values) => await request.put('/admin/supscription/pkg/pack', { ...values, subscrPkgPackId: key }),
    remove: async (key) => await request.delete('/admin/supscription/pkg/pack', { data: { subscrPkgPackId: key } })
});

export const packPackagesDataGrid = (subscrPkgPackId) => new CustomStore({
    key: 'subscrPkgId',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });

            if (subscrPkgPackId) params += `subscrPkgPackId=${subscrPkgPackId}&`;
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/supscription/pkg/pack/pkgs${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/supscription/pkg/pack/pkgs', { subscrPkgPackId, subscrPkgsIds: [values.subscrPkgId] }),
    remove: async (key) => await request.delete('/admin/supscription/pkg/pack/pkgs', { data: { subscrPkgId: key, subscrPkgPackId } })
});

export const unitPackagesRelatedCourses = (subscrPkgId, courseId) => new CustomStore({
    key: '',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });

            if (subscrPkgId) params += `subscrPkgId=${subscrPkgId}&`;
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/admin/supscription/pkg/course/opts${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.post('/admin/supscription/pkg/course/opt', { ...values, subscrPkgId }),
    update: async (key, values) => await request.post('/admin/supscription/pkg/course/opt', { ...values, subscrPkgId }),
    remove: async (key) => Promise.resolve()
});

export const packageUnitsDataGrid = (packageId, courseId) => new CustomStore({
    key: 'unitId',
    load: async (loadOptions) => {
        try {
            let params = '?';
            ['skip', 'take', 'group', 'filter', 'sort']
                .forEach(function (i) {
                    if (i in loadOptions && loadOptions[i]) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                    }
                });

            if (courseId) params += `courseId=${courseId}&`;
            params = params.slice(0, -1);
            const { data: { data, allCount: totalCount } } = await request.get(`/supscription/package/${packageId}/units${params}`);
            return { data, totalCount };
        } catch (err) {
            return err;
        }
    },
    insert: async (values) => await request.put('/supscription/package/units', { units: [values], packageId }),
    update: async (key, values) => await request.put('/supscription/package/units', { units: [{ unitId: key, isVisible: values.isVisible }], packageId }),
    remove: async (key) => await request.delete('/supscription/package/units', { data: { unitsIds: [key], packageId } })
});
